import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";

import {
    bulkUpdateProductsStatus,
    bulkAdjustProductsPrice,
    bulkAssignProductsCategory,
    bulkAssignProductsTag,
} from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const buildHook = (mutationFn, fallbackError) => () => {
    const queryClient = useQueryClient();
    const { mutate, mutateAsync, isPending } = useMutation({
        mutationFn,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["products"] });
        },
        onError: (error) => {
            toast.error(parseError(error) || fallbackError);
        },
    });
    return { mutate, mutateAsync, isPending };
};

export const useBulkUpdateProductsStatus   = buildHook(bulkUpdateProductsStatus,   "Failed to update statuses");
export const useBulkAdjustProductsPrice    = buildHook(bulkAdjustProductsPrice,    "Failed to adjust prices");
export const useBulkAssignProductsCategory = buildHook(bulkAssignProductsCategory, "Failed to assign category");
export const useBulkAssignProductsTag      = buildHook(bulkAssignProductsTag,      "Failed to assign tag");
